import { render, staticRenderFns } from "./group-avatar.vue?vue&type=template&id=34bf967f&"
import script from "./group-avatar.vue?vue&type=script&lang=js&"
export * from "./group-avatar.vue?vue&type=script&lang=js&"
import style0 from "./group-avatar.vue?vue&type=style&index=0&id=34bf967f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports